import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material"
import React from "react"
import { NavLink } from "react-router-dom"

export default function NavBar() {
  return (
    <AppBar position="fixed" elevation={0} sx={{ bgcolor: "white" }}>
      <Toolbar>
        <Box sx={{ flexGrow: 1 }}>
          <Box component={NavLink} to="/" sx={{ display: "inline-flex" }}>
            <Box
              component="img"
              alt="OSTech Logo"
              src={"./assets/OST_Logo2.bmp"}
              sx={{ width: { xs: "10em", sm: "15em" }, display: "flex" }}
            />
          </Box>
        </Box>
        <Button
          component={NavLink}
          to="/inquiry"
          color="primary"
          variant="contained"
          sx={{ borderRadius: 28, mr: { xs: "1em", sm: "4em" } }}
        >
          <Typography color="white">ご登録・お問い合わせ</Typography>
        </Button>
      </Toolbar>
    </AppBar>
  )
}
